import React, { useEffect, useId, useRef, useState } from "react";
import { formatRocDate, rocDateToIso } from "../../utils/rocDate";

export default function RocDateInput({ value = "", onChange, commitOnBlur = true, disabled, className, required = false }) {
  const [draft, setDraft] = useState(() => formatRocDate(value));
  const [error, setError] = useState(false);
  const focused = useRef(false);
  const errorId = useId();
  useEffect(() => {
    if (!focused.current) setDraft(formatRocDate(value));
  }, [value]);

  const commit = () => {
    const iso = rocDateToIso(draft);
    setError(iso === null);
    if (iso === null) return;
    setDraft(formatRocDate(iso));
    if (iso !== value) onChange?.(iso);
  };

  return (
    <div className="min-w-0">
      <input
        type="text"
        inputMode="numeric"
        aria-label="出生年月日（民國）"
        aria-invalid={error || undefined}
        aria-describedby={error ? errorId : undefined}
        placeholder="078/11/22"
        className={className}
        value={draft}
        disabled={disabled}
        required={required}
        onFocus={() => { focused.current = true; }}
        onChange={e => {
          const next = e.target.value;
          setDraft(next);
          setError(false);
          if (!commitOnBlur) onChange?.(rocDateToIso(next) || "");
        }}
        onBlur={() => { focused.current = false; commit(); }}
        onKeyDown={e => {
          if (e.key === "Enter") { e.preventDefault(); commit(); }
        }}
      />
      {error && <p id={errorId} role="alert" className="text-xs text-red-500 mt-1">請輸入有效的民國年月日，例如 078/11/22 或 0781122</p>}
    </div>
  );
}
